export const DIFFICULTY_LEVEL = ["Beginner", "Intermediate", "Advanced"];
export const BUSSINESS_TYPES = [
  {
    id: "b2b",
    title: "B2B",
    description: "Business to Business",
  },
  {
    id: "b2c",
    title: "B2C",
    description: "Business to Consumer",
  }
];

export const ORGANIZATION_TYPES = [
  {
    id: "agency",
    title: "Agency",
    description: "Marketing/Advertising Agency",
  },
  {
    id: "brand",
    title: "Brand",
    description: "Direct Brand/Company",
  }
];

export const INTERVIEW_PREVIEW_DEFAULT_FIELDS = [
  { key: "interviewName", label: "Name", defaultValue: "Custom Interview" },
  { key: "categoryName", label: "Category", badge: true, defaultValue: "marketing" },
  {
    key: "duration",
    label: "Duration",
    defaultValue: "15 minutes",
    format: (v) => (v ? `${v} minutes` : "15 minutes"),
  },
  {
    key: "difficulty",
    label: "Difficulty",
    badge: true,
    color: "bg-green-50 text-green-600",
    defaultValue: "Beginner",
  },
];

export const INTERVIEW_PREVIEW_EXTRA_FIELDS = {
  interviewType: "Interview Type",
  industryType: "Industry",
  organizationType: "Organization",
  businessType: "Business Type",
  interviewRole: "Interviewer Role",
  interviewTone: "Tone",
};

export const STATUS_OPTIONS = [
  { value: "all", label: "All Status" },
  { value: "pending", label: "Pending" },
  { value: "completed", label: "Completed" },
  { value: "expired", label: "Expired" },
];

export const VALID_STATUSES = ["pending", "scheduled", "confirmed", "completed", "cancelled", "expired"];

export const SCHEDULE_TABLE_HEAD = [
  "Student",
  "Interview Type",
  "Start At",
  "End At",
  "Duration",
  "Status",
  "Actions",
];

export const SCHEDULE_PRACTICE_DATA = [
  {
    title: "Agency Paid Media - Meta and Google",
    duration: 30,
    credits: 8,
    totalAttempts: 45,
    avgScore: 76,
    weekAttempts: 12,
    active: true,
  },
  {
    title: "Cold Call",
    duration: 15,
    credits: 5,
    totalAttempts: 89,
    avgScore: 82,
    weekAttempts: 23,
    active: true,
  },
  {
    title: "Agency SEO",
    duration: 30,
    credits: 8,
    totalAttempts: 12,
    avgScore: 68,
    weekAttempts: 2,
    active: false,
  },
];

export const getScheduleButtonData = (SvgMapper) => [
  { color: "bg-yellow-400", icon: SvgMapper.plus("w-4 h-4"), label: "Schedule Interview" },
];

export const getScheduleTabs = (SvgMapper, ScheduleTable) => [
  { label: "List View", key: "list", icon: () => SvgMapper.users("w-4 h-4"), content: <ScheduleTable /> },
];